import React from 'react';

import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { AModal } from 'components/shared/AModal';
import { IAModalProps } from 'components/shared/AModal/types';
import { setAppHasChangesAction } from 'store/unsavedChanges';
import { appHasChangesSelector } from 'store/unsavedChanges/selectors';

import { useEventModal } from '../../useEventModal';
import { BackButtonWithTooltip } from '../shared';
import { DetailsScene } from '../shared/DetailsScene';
import { EPageType } from '../shared/DetailsScene/types';
import sharedStyles from '../shared/index.module.css';
import { PageScene } from '../shared/PageScene';
import { useActivityWizardContext, withWizardContext } from './context';
import * as scenes from './Scenes';

const ActivityTripEventModalContent = withWizardContext(() => {
  const dispatch = useDispatch();
  const isPageHasChanges = useSelector(appHasChangesSelector);
  const contextData = useActivityWizardContext();
  const modalData = { ...contextData, initialValues: contextData.data.default };
  const { tripEvent, step, previousStep, detailsFormProps } = contextData;
  const { modalHeader, res } = useEventModal({ tripEvent });

  const onReturn = step === 'default' ? undefined : previousStep;
  const isChangesWarning = isPageHasChanges || detailsFormProps.hasChanges || detailsFormProps.isFilled;

  const modalProps: Pick<
    IAModalProps,
    'header' | 'headerPlacement' | 'withoutCloseBtn' | 'onReturn' | 'size' | 'withoutPadding'
  > = {
    header: step === 'default' ? modalHeader : 'Create New Content',
    headerPlacement: step === 'default' ? undefined : 'center',
    withoutCloseBtn: step === 'default' ? false : true,
    withoutPadding: step === 'page' || step === 'details',
    size: step === 'page' ? 'xl' : 'xlg',
    onReturn,
  };

  const handleBackButtonOnClick = () => {
    previousStep();
    dispatch(setAppHasChangesAction(false));
  };

  const customBackButton = (() => {
    if (!onReturn) return null;
    if (!isChangesWarning) return null;
    return <BackButtonWithTooltip onClick={handleBackButtonOnClick} />;
  })();

  return (
    <AModal
      bodyClassName={cx(sharedStyles.bodyModal)}
      headerClassName={sharedStyles.headerModal}
      isOpen
      onClose={() => res.success(false)}
      customBackButton={customBackButton}
      isCloseOnEsc
      {...modalProps}
    >
      {step === 'default' && <scenes.Activity />}
      {step === 'details' && <DetailsScene modalData={modalData} type="default" initialType={EPageType.ACTIVITY} />}
      {step === 'page' && <PageScene modalData={modalData} />}
    </AModal>
  );
});

export { ActivityTripEventModalContent };
